exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Y_XumWMzujZiskxQuH-7y {\n  font-size: 1.7vw;\n  line-height: 2.2vw;\n  color: #FFF;\n  opacity: .8;\n  position: absolute;\n  bottom: 3.5vw;\n  right: 4vw;\n  margin: 0;\n  font-weight: 300; }\n\n@-webkit-keyframes _12sUvXcZlrD_gbupwHAjT- {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes _12sUvXcZlrD_gbupwHAjT- {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n._12sUvXcZlrD_gbupwHAjT- {\n  -webkit-animation: _12sUvXcZlrD_gbupwHAjT- 1.5s 1 ease;\n  animation: _12sUvXcZlrD_gbupwHAjT- 1.5s 1 ease; }\n\n._3hA6k27fhOYegbns9nlgee {\n  position: relative; }\n  ._3hA6k27fhOYegbns9nlgee ._3HeyNt0jDC_5x8I1oVwIHX {\n    background-size: cover !important;\n    background-position: center center !important;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: -3; }\n  ._3hA6k27fhOYegbns9nlgee .Y_XumWMzujZiskxQuH-7y {\n    font-size: 1.7vw;\n    line-height: 2.2vw;\n    color: #FFF;\n    opacity: .8;\n    position: absolute;\n    bottom: 3.5vw;\n    right: 4vw;\n    margin: 0;\n    font-weight: 300; }\n", ""]);

// exports
exports.locals = {
	"version": "Y_XumWMzujZiskxQuH-7y",
	"fade_in": "_12sUvXcZlrD_gbupwHAjT-",
	"fadeIn": "_12sUvXcZlrD_gbupwHAjT-",
	"app_container": "_3hA6k27fhOYegbns9nlgee",
	"appContainer": "_3hA6k27fhOYegbns9nlgee",
	"background": "_3HeyNt0jDC_5x8I1oVwIHX"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&camelCase=true!./node_modules/sass-loader/lib/loader.js!./src/layouts/styles.scss
// module id = 1710
// module chunks = 0